import React, { PureComponent } from 'react'
import Slider from 'react-slick'

import { NextArrow, PrevArrow } from 'components/ui/SliderArrows'

/*VIEW*/
// import Img from "components/Img";

/*Ui*/
// import Cont from 'components/ui/Cont'

import './style'
import './media'


class DocsSlider extends PureComponent {
    SETTINGS = {
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        speed: 200,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        touchMove: true,
        focusOnSelect: true,
        swipeToSlide: true,
        infinite: false,
        centerMode: false,
        // variableWidth: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    dots: false,
                }
            },
            {
              breakpoint: 1000,
              settings: {
                  slidesToShow: 2,
                  dots: false,
              }
          },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 2,
                    dots: true,
                    arrows: false,
                }
            },
            {
                breakpoint: 450,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                    centerMode: false,
                }
            },
        ]
    }

    render() {
        const { children, slidesToShow, ...other } = this.props

        return (
            <Slider
                { ...this.SETTINGS}
                className="docs-slider"
            >
                {children}
            </Slider>
        );
    }
}

export default DocsSlider